module.exports = __webpack_public_path__ + "static/media/plinklogo.d877ee10.png";